import Vue from 'vue'
import Router from 'vue-router'

import Login from './views/Login.vue'
import Layout from './views/Layout/Layout.vue'
import Home from './views/home'
import Stage from './views/Stage/index.vue'

const _import = file => () => import('@/views/' + file + '.vue')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      component: Login,
      name: 'login',
    },
    {
      path: '/',
      component: Home,
    },
    {
      path: '/patient',
      component: Layout,
      // redirect: '/patient',
      children: [
        {
          path: '/patient/list',
          name: 'PatientList',
          component: _import('Patient/List'),
        },
        {
          path: '/patient/record',
          name: 'PatientRecord',
          component: _import('Patient/Record'),
        },
      ],
    },
    {
      path: '/training',
      component: Layout,
      children: [
        {
          path: '/training/classification',
          name: 'TrainingClassification',
          component: _import('Training/Classification'),
        },
        {
          path: '/training/programs',
          name: 'TrainingPrograms',
          component: _import('Training/Programs'),
        },
      ],
    },
    {
      path: '/rs',
      component: _import('TherapyFrame/RsFrame'),
      name: 'rs',
    },
    {
      path: '/3d',
      component: _import('TherapyFrame/TDFrame'),
      name: '3d',
    },
    {
      path: '/therapy',
      name: 'stage',
      component: Stage,
      // children: [
      //   {
      //     path: '/:cur',
      //     name: 'CurrentTherapy',
      //     component: () => import(`@therapy/scenes/${kids}/settings.vue`),
      //   },
      // ],
    },

    {
      path: '/',
      component: Layout,
      redirect: '/settings',
      children: [
        {
          path: 'settings',
          name: 'Settings',
          component: _import('AppSettings/index'),
        },
      ],
    },
    {
      path: '/404',
      component: _import('404'),
      name: '404',
    },
  ],
})
